import { colors } from "assets/styles/colors";

import styled from "styled-components";
import LogoText from "assets/images/login_back.jpg";

export const LoginWrapper = styled.div`
    width:100%;
    display: grid;
    grid-template-columns: 300px 1fr;
    justify-content:center;
    align-items:center;
    background: url(${LogoText}) no-repeat center center;
    background-size: cover;
    @media (max-width: 1124px) {
        grid-template-columns: 1fr;
}
`

export const LeftWrap = styled.div`
    height:60vh;
    background-size: cover;
    padding-left: 70px;
    display:flex;
    flex-direction:column;
    justify-content: end;

    @media (max-width: 768px) {
        height: 32px;
    }
         @media (max-width: 1124px) {
       display: none;
}

`
export const RightWrap = styled.div<any>`
position:relative;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;

direction:${(props) => props.direction};
`

export const LoginTemplate = styled.div`
width:50%;
padding:40px 0;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
z-index: 1111;
h2{
    text-align: center;
}
button{
    svg{
        fill:#fff;
    }
}

 @media (max-width: 768px) {
    width:100%;
    padding:20px;
    }
}

`

export const ForgotPassword = styled.p`
margin-top: 15px;
    text-align: right;
    width: 100%;
`

export const SocialButton = styled.button`
    width: 100%;
    height: 44px;
    display: flex;
    gap: 15px;
    border-radius: 8px;
    border: 1px solid #D0D5DD;
    margin-top: 12px;
    justify-content: center;
    font-weight: 500;
    background: #fff;
    padding: 0;
    div{
        display: flex;
        gap: 15px;
        justify-content: center;
        align-items:center;
        width:100%;
        height:100%;
    }

`

export const DontAccount = styled.div`
margin-top: 35px;
    text-align: center;
    width: 100%;
    margin-bottom:15px;
    font-size:15px;
    a{
        color:${colors?.primary} !important;
        font-weight:bold ;
    }
`


export const SignupTemplate = styled.div`
width:50%;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
z-index: 1111;

`


export const OTPTemplate = styled.div`
width:70%;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
text-align:center;
z-index: 1111;
.__otp_input input {
    width: 40px !important;
    margin: 0 6px;
    height: 40px;
    border: 1px solid #D0D5DD;
    border-radius: 10px;
}

`


export const ForgotTemplate = styled.div`
width:35%;
max-width:380px;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
text-align:center;
z-index: 1111;
margin-bottom: 20px;
.__otp_input input {
    width: 40px !important;
    margin: 0 6px;
    height: 40px;
    border: 1px solid #D0D5DD;
    border-radius: 10px;
}

`